import { render, staticRenderFns } from "./IconEditDebtor.vue?vue&type=template&id=648fedd4&"
import script from "./IconEditDebtor.vue?vue&type=script&lang=js&"
export * from "./IconEditDebtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports